module.exports = __webpack_public_path__ + "static/img/pay-success-vip-avatar.d4eef29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/member-system/pay-success-vip-avatar.png
// module id = R9+s
// module chunks = 213